module.exports = __webpack_public_path__ + "components/flag/static/square/aw-5c338589a181ea52c59f690266d4d4b5.svg";